import React from 'react';
import PropTypes from 'prop-types'
import './StepIcon.less';

function StepIcon({status, number}) {
  if (status === 'completed') {
    return (
      <div className={`StepIcon__oval StepIcon__oval--${status}`}>
        <div className={`StepIcon__text StepIcon__text--${status}`}>
          <i className="icon-ok"/>
        </div>
      </div>
    );
  }

  return (
    <div className={`StepIcon__oval StepIcon__oval--${status}`}>
      <div className={`StepIcon__text StepIcon__text--${status}`}>
        {number}
      </div>
    </div>
  );
}

StepIcon.propTypes = {
  status: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired
}

export default StepIcon;
